import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          color: '#fff'
        }
      }
    },
    MuiTooltip: {
      defaultProps: {
        arrow: true
      },
      styleOverrides: {
        tooltip: {
          fontSize: '1rem'
        }
      }
    }
  },
  palette: {
    primary: {
      main: '#243F81'
    },
    secondary: {
      main: '#f50057'
    }
  }
});
